/* ============================================
   FilePreview — Compact preview bar for attached file
   Shows thumbnail for images, icon + name for others
   ============================================ */
import { useState, useEffect } from 'react'
import { IconFile, IconX } from '@/components/icons/Icons'

interface FilePreviewProps {
  file: File
  onRemove: () => void
}

function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export default function FilePreview({ file, onRemove }: FilePreviewProps) {
  const [thumbUrl, setThumbUrl] = useState<string | null>(null)
  const isImage = file.type.startsWith('image/')

  useEffect(() => {
    if (!isImage) return
    const url = URL.createObjectURL(file)
    setThumbUrl(url)
    return () => URL.revokeObjectURL(url)
  }, [file, isImage])

  return (
    <div className="chat-input__file-preview">
      {isImage && thumbUrl ? (
        <img
          src={thumbUrl}
          alt={file.name}
          className="chat-input__file-preview-thumb"
        />
      ) : (
        <div className="chat-input__file-preview-icon">
          <IconFile size={20} />
        </div>
      )}
      <div className="chat-input__file-preview-info">
        <span className="chat-input__file-preview-name">{file.name}</span>
        <span className="chat-input__file-preview-size">{formatSize(file.size)}</span>
      </div>
      <button
        className="chat-input__file-preview-remove"
        onClick={onRemove}
        type="button"
        title="Quitar archivo"
      >
        <IconX size={16} />
      </button>
    </div>
  )
}
